import React from 'react'
import { DevPanelData } from '../types'
import List from 'components/Common/List'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import ExpandableObjectView from '../ExpandableObjectView'
import MessageBanner from 'LuxKit/Banners/MessageBanner'

interface Props {
  state: DevPanelData
}

function ContextsTab({ state }: Props) {
  const { contexts } = state

  return <Pane padding={20}>
    <VerticalSpacer gap={16}>
      <Heading variant="heading5">Contexts</Heading>

      <div>
        {contexts.length === 0 && <BodyText variant="medium" italics>None</BodyText>}

        {contexts.length > 0 && <List>
          {contexts.map(ctx => <li key={ctx.id}>
            <BodyText variant="medium" as="span">{ctx.name}</BodyText><br />
            <ExpandableObjectView value={ctx.value} />
          </li>)}
        </List>}
      </div>

      <MessageBanner kind="informational-primary">
        Want to add a context here? Use the <b>useReportContextToDevPanel()</b> hook.
      </MessageBanner>
    </VerticalSpacer>
  </Pane>
}

export default ContextsTab
